var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6646_5026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0103 6.73886C12.0103 5.50428 11.0095 4.50342 9.77488 4.50342H2.23545C1.00086 4.50342 0 5.5042 0 6.73886V36.6877C0 38.517 1.48298 39.9999 3.31223 39.9999H30.7013C32.1781 39.9999 33.3754 38.8026 33.3754 37.3258V11.6484C33.3754 10.1716 32.1781 8.97431 30.7013 8.97431H14.2458C13.0111 8.97431 12.0103 7.97345 12.0103 6.73886Z",
    fill: "url(#paint0_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7014 8.9743H26.7512V39.9999H30.7014C32.1783 39.9999 33.3755 38.8026 33.3755 37.3258V11.6484C33.3754 10.1716 32.1783 8.9743 30.7014 8.9743Z",
    fill: "url(#paint1_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7014 8.9743H26.7512V39.9999H30.7014C32.1783 39.9999 33.3755 38.8026 33.3755 37.3258V11.6484C33.3754 10.1716 32.1783 8.9743 30.7014 8.9743Z",
    fill: "url(#paint2_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3754 37.3258V19.1142H0V36.6876C0 38.517 1.48298 39.9999 3.31223 39.9999H30.7013C32.1782 39.9999 33.3754 38.8027 33.3754 37.3258Z",
    fill: "url(#paint3_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9586 11.5044L22.2444 6.96537L25.6956 1.86028C26.9189 0.0507975 29.2063 -0.54026 30.8045 0.540208L31.731 1.16648C33.3292 2.24695 33.6331 4.58977 32.4099 6.39933L28.9586 11.5044Z",
    fill: "url(#paint4_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7952 29.761L11.2222 31.7857C10.6508 32.0386 10.0117 31.6066 10.0335 30.9821L10.2082 25.984C10.2374 25.147 10.5017 24.335 10.9708 23.6412L23.1667 5.60095L29.881 10.14L17.6851 28.1803C17.216 28.8741 16.5611 29.4219 15.7952 29.761Z",
    fill: "url(#paint5_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9709 23.6412C10.7265 24.0027 10.5384 24.3963 10.4094 24.8087L16.811 29.1364C17.1456 28.863 17.4408 28.5417 17.6852 28.1802L29.8811 10.1399L23.1668 5.60089L10.9709 23.6412Z",
    fill: "url(#paint6_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9749 24.996C12.7305 25.3575 12.5104 25.7296 12.3201 26.1005L14.9001 27.8447C15.1734 27.5299 15.4366 27.1869 15.681 26.8255L27.8769 8.78522L25.1708 6.95581L12.9749 24.996Z",
    fill: "url(#paint7_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9985 13.2457C17.895 13.3989 17.846 13.5865 17.8506 13.8014L24.2522 18.129C24.4533 18.0533 24.6092 17.938 24.7127 17.7848L29.8808 10.1401L23.1666 5.60107L17.9985 13.2457Z",
    fill: "url(#paint8_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2854 9.70347L23.421 5.06285C22.8883 4.70269 22.7484 3.97893 23.1086 3.44622L23.1635 3.36481C23.5237 2.83211 24.2475 2.69219 24.7802 3.05234L31.6445 7.69288C32.1772 8.05304 32.3172 8.7768 31.957 9.30951L31.902 9.39092C31.5419 9.9237 30.8181 10.0635 30.2854 9.70347Z",
    fill: "url(#paint9_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9264 11.7139L22.0619 7.07335C21.5292 6.71319 21.3893 5.98943 21.7494 5.45672L21.8044 5.37531C22.1646 4.8426 22.8883 4.70268 23.421 5.06284L30.2854 9.70338C30.8181 10.0635 30.958 10.7873 30.5979 11.32L30.5429 11.4014C30.1828 11.9341 29.4591 12.074 28.9264 11.7139Z",
    fill: "url(#paint10_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0819 29.5962L10.0335 30.982C10.0117 31.6065 10.6508 32.0385 11.2222 31.7856L12.4901 31.2242L10.0819 29.5962Z",
    fill: "url(#paint11_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6751 36.6062C35.2607 38.5837 33.517 39.9999 31.4965 39.9999H3.31226C5.187 39.9999 6.80503 38.6858 7.1895 36.8509L11.5897 15.8514C11.8404 14.6553 12.8951 13.7986 14.1173 13.7986H38.0321C39.2808 13.7986 40.2135 14.947 39.9574 16.1692L35.6751 36.6062Z",
    fill: "url(#paint12_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6751 36.6062C35.2607 38.5837 33.517 39.9999 31.4965 39.9999H3.31226C5.187 39.9999 6.80503 38.6858 7.1895 36.8509L11.5897 15.8514C11.8404 14.6553 12.8951 13.7986 14.1173 13.7986H38.0321C39.2808 13.7986 40.2135 14.947 39.9574 16.1692L35.6751 36.6062Z",
    fill: "url(#paint13_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9575 16.1694L35.6751 36.6062C35.2602 38.5835 33.5167 39.9999 31.4963 39.9999H27.7881L33.2775 13.7984H38.032C39.2806 13.7984 40.2132 14.9466 39.9575 16.1694Z",
    fill: "url(#paint14_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3755 37.3259V13.7986H17.7256V39.9999H30.7015C32.1783 39.9999 33.3755 38.8028 33.3755 37.3259Z",
    fill: "url(#paint15_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3758 13.7984V37.3262C33.3758 38.8031 32.1781 39.9999 30.7013 39.9999H18.7711L10.5703 31.7992C10.7695 31.8784 11.0009 31.8839 11.2221 31.7858L15.7954 29.7607C16.5609 29.4219 17.2158 28.8744 17.6856 28.1803L27.4079 13.7984H33.3758Z",
    fill: "url(#paint16_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 13.7986L10.971 23.6412C10.5019 24.3351 10.2377 25.147 10.2084 25.984L10.0337 30.9821C10.0119 31.6065 10.6511 32.0386 11.2224 31.7857L15.7955 29.761C16.5613 29.4219 17.2162 28.8741 17.6853 28.1803L27.4078 13.7986H17.625Z",
    fill: "url(#paint17_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4078 13.7984L17.6855 28.1803C17.4408 28.5419 17.1459 28.8635 16.811 29.1364L14.9004 27.8446L12.32 26.1003L10.4094 24.8086C10.5381 24.396 10.7263 24.0023 10.971 23.6415L17.6251 13.7984H27.4078Z",
    fill: "url(#paint18_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4879 13.7984L15.6808 26.8258C15.4369 27.1866 15.1734 27.5301 14.9005 27.8446L12.3201 26.1003C12.5107 25.7294 12.7303 25.3576 12.975 24.996L20.5452 13.7984H24.4879Z",
    fill: "url(#paint19_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0821 29.5962L10.0337 30.982C10.0119 31.6065 10.6511 32.0385 11.2224 31.7856L12.4904 31.2242L10.0821 29.5962Z",
    fill: "url(#paint20_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6751 36.6062L38.305 24.0552H9.87075L7.18958 36.8509C6.80503 38.6858 5.187 39.9999 3.31226 39.9999H31.4964C33.5169 39.9999 35.2607 38.5837 35.6751 36.6062Z",
    fill: "url(#paint21_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3051 24.0552L39.9575 16.1692C40.2135 14.9471 39.281 13.7988 38.0325 13.7986H14.117C12.895 13.7989 11.8404 14.6554 11.5898 15.8515L9.87085 24.0553L38.3051 24.0552Z",
    fill: "url(#paint22_linear_6646_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9575 16.1694L35.6751 36.6062C35.2602 38.5835 33.5167 39.9999 31.4963 39.9999H27.7881L33.2775 13.7984H38.032C39.2806 13.7984 40.2132 14.9466 39.9575 16.1694Z",
    fill: "url(#paint23_linear_6646_5026)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6646_5026",
    x1: 2.99639,
    y1: 10.6089,
    x2: 25.3583,
    y2: 32.9708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6646_5026",
    x1: 30.1598,
    y1: 24.4871,
    x2: 34.4212,
    y2: 24.4871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6646_5026",
    x1: 26.4244,
    y1: 22.3272,
    x2: 22.1107,
    y2: 18.9547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6646_5026",
    x1: 16.6877,
    y1: 25.6983,
    x2: 16.6877,
    y2: 40.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6646_5026",
    x1: 26.8625,
    y1: 1.36232,
    x2: 27.9605,
    y2: 6.48655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAEE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6646_5026",
    x1: 18.7401,
    y1: 19.5343,
    x2: 21.4882,
    y2: 22.2826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6646_5026",
    x1: 16.7668,
    y1: 14.5079,
    x2: 23.1982,
    y2: 20.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6646_5026",
    x1: 21.4175,
    y1: 18.5146,
    x2: 17.2346,
    y2: 15.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6646_5026",
    x1: 23.8409,
    y1: 11.8018,
    x2: 27.5189,
    y2: 8.12389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6646_5026",
    x1: 28.0066,
    y1: 5.5761,
    x2: 26.6471,
    y2: 7.8768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6646_5026",
    x1: 26.9159,
    y1: 7.39029,
    x2: 25.3995,
    y2: 9.4295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6646_5026",
    x1: 11.2868,
    y1: 31.2984,
    x2: 11.3222,
    y2: 31.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6646_5026",
    x1: 16.5836,
    y1: 13.9479,
    x2: 25.9643,
    y2: 39.3931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6646_5026",
    x1: 16.5836,
    y1: 13.9479,
    x2: 25.9643,
    y2: 39.3931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6646_5026",
    x1: 33.7919,
    y1: 27.0983,
    x2: 39.1252,
    y2: 28.5101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6646_5026",
    x1: 26.0929,
    y1: 26.4262,
    x2: 43.7541,
    y2: 21.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6646_5026",
    x1: 25.5844,
    y1: 26.4796,
    x2: 17.1138,
    y2: 19.2116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6646_5026",
    x1: 17.404,
    y1: 19.3456,
    x2: 23.4432,
    y2: 33.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6646_5026",
    x1: 16.198,
    y1: 14.3034,
    x2: 23.9365,
    y2: 28.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6646_5026",
    x1: 22.0562,
    y1: 20.8745,
    x2: 8.04314,
    y2: 20.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6646_5026",
    x1: 9.88151,
    y1: 28.7181,
    x2: 12.4697,
    y2: 33.4239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6646_5026",
    x1: 20.8086,
    y1: 33.9054,
    x2: 20.8086,
    y2: 41.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6646_5026",
    x1: 24.7831,
    y1: 18.9648,
    x2: 23.3713,
    y2: 11.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6646_5026",
    x1: 33.7919,
    y1: 27.0983,
    x2: 39.1252,
    y2: 28.5101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6646_5026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolFolder);
export default __webpack_public_path__ + "static/media/tool-folder.5665cff8bf767530f1cf825c759e03b4.svg";
export { ForwardRef as ReactComponent };